var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loggedinuser"},[_c('loader',{attrs:{"loading":_vm.loading}}),_c('img',{staticClass:"usericon",attrs:{"src":require('@/assets/images/user.svg'),"alt":"User"}}),_vm._v(_vm._s(_vm.user.name)+" "),_c('span',{on:{"click":function($event){return _vm.logOut()}}},[_vm._v("(Logout)")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }